
export interface PriceDropNotification {
  id: number;
  productId: number;
  productName: string;
  productImage: string;
  retailer: string;
  originalPrice: number;
  targetPrice: number;
  droppedPrice: number;
  dropPercentage: number;
  status: 'triggered' | 'expired' | 'active';
  createdAt: string;
  triggeredAt: string | null;
  expiresAt: string;
}

export const priceDropNotifications: PriceDropNotification[] = [
  {
    id: 1,
    productId: 1,
    productName: 'iPad Pro M2',
    productImage: 'https://readdy.ai/api/search-image?query=Modern%20sleek%20iPad%20Pro%20M2%20tablet%20computer%20with%20advanced%20display%20technology%20showing%20colorful%20screen%20content%2C%20minimalist%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20high-tech%20aesthetic&width=200&height=200&seq=alert1&orientation=squarish',
    retailer: 'Amazon',
    originalPrice: 1199,
    targetPrice: 1050,
    droppedPrice: 999,
    dropPercentage: 17,
    status: 'triggered',
    createdAt: '2024-05-01T10:30:00Z',
    triggeredAt: '2024-06-15T08:45:00Z',
    expiresAt: '2024-08-01T10:30:00Z',
  },
  {
    id: 2,
    productId: 5,
    productName: 'iPhone 15 Pro',
    productImage: 'https://readdy.ai/api/search-image?query=Latest%20iPhone%2015%20Pro%20smartphone%20with%20natural%20titanium%20finish%2C%20advanced%20triple%20camera%20system%2C%20premium%20materials%2C%20sleek%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20cutting-edge%20mobile%20technology&width=200&height=200&seq=alert2&orientation=squarish',
    retailer: 'Best Buy',
    originalPrice: 1099,
    targetPrice: 950,
    droppedPrice: 899,
    dropPercentage: 18,
    status: 'triggered',
    createdAt: '2024-04-15T14:20:00Z',
    triggeredAt: '2024-06-10T11:30:00Z',
    expiresAt: '2024-07-15T14:20:00Z',
  },
  {
    id: 3,
    productId: 6,
    productName: 'LG 27" 4K Monitor',
    productImage: 'https://readdy.ai/api/search-image?query=Ultra-wide%20LG%2027%20inch%204K%20monitor%20display%20with%20thin%20bezels%2C%20modern%20adjustable%20stand%2C%20professional%20grade%20IPS%20screen%20showing%20vibrant%20colors%2C%20sleek%20black%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20computer%20display%20technology&width=200&height=200&seq=alert3&orientation=squarish',
    retailer: 'Amazon',
    originalPrice: 899,
    targetPrice: 650,
    droppedPrice: 599,
    dropPercentage: 33,
    status: 'triggered',
    createdAt: '2024-03-20T09:15:00Z',
    triggeredAt: '2024-05-25T16:00:00Z',
    expiresAt: '2024-06-20T09:15:00Z',
  },
  {
    id: 4,
    productId: 7,
    productName: 'MacBook Pro M3 Pro',
    productImage: 'https://readdy.ai/api/search-image?query=MacBook%20Pro%20laptop%20computer%20with%20M3%20Pro%20chip%2C%20space%20gray%20aluminum%20unibody%20finish%2C%20premium%20build%20quality%2C%20thin%20profile%20showing%20keyboard%20and%20display%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20professional%20computing%20device&width=200&height=200&seq=alert4&orientation=squarish',
    retailer: 'B&H Photo',
    originalPrice: 2199,
    targetPrice: 1900,
    droppedPrice: 0,
    dropPercentage: 0,
    status: 'active',
    createdAt: '2024-06-01T12:00:00Z',
    triggeredAt: null,
    expiresAt: '2024-09-01T12:00:00Z',
  },
  {
    id: 5,
    productId: 8,
    productName: 'ASUS WiFi 7 Router',
    productImage: 'https://readdy.ai/api/search-image?query=High-speed%20ASUS%20WiFi%207%20gaming%20router%20with%20multiple%20external%20antennas%2C%20aggressive%20modern%20black%20design%20with%20RGB%20LED%20accents%2C%20advanced%20networking%20technology%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20networking%20equipment&width=200&height=200&seq=alert5&orientation=squarish',
    retailer: 'Newegg',
    originalPrice: 349,
    targetPrice: 220,
    droppedPrice: 199,
    dropPercentage: 43,
    status: 'triggered',
    createdAt: '2024-04-01T08:00:00Z',
    triggeredAt: '2024-05-15T10:20:00Z',
    expiresAt: '2024-07-01T08:00:00Z',
  },
  {
    id: 6,
    productId: 2,
    productName: 'Dyson Supersonic',
    productImage: 'https://readdy.ai/api/search-image?query=Futuristic%20Dyson%20Supersonic%20hair%20dryer%20with%20innovative%20bladeless%20design%2C%20premium%20fuchsia%20and%20nickel%20finish%2C%20sleek%20curves%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20high-tech%20beauty%20device&width=200&height=200&seq=alert6&orientation=squarish',
    retailer: 'Sephora',
    originalPrice: 479,
    targetPrice: 380,
    droppedPrice: 0,
    dropPercentage: 0,
    status: 'expired',
    createdAt: '2024-02-01T15:30:00Z',
    triggeredAt: null,
    expiresAt: '2024-05-01T15:30:00Z',
  },
  {
    id: 7,
    productId: 4,
    productName: 'Vitamix Blender',
    productImage: 'https://readdy.ai/api/search-image?query=High-performance%20Vitamix%20professional%20blender%20with%20powerful%20motor%20base%2C%20large%20clear%20container%2C%20modern%20black%20and%20stainless%20steel%20design%2C%20pure%20white%20background%2C%20centered%20composition%2C%20professional%20product%20photography%20style%2C%20no%20shadows%2C%20premium%20kitchen%20appliance&width=200&height=200&seq=alert7&orientation=squarish',
    retailer: 'Williams Sonoma',
    originalPrice: 599,
    targetPrice: 480,
    droppedPrice: 449,
    dropPercentage: 25,
    status: 'triggered',
    createdAt: '2024-03-10T11:45:00Z',
    triggeredAt: '2024-05-20T09:00:00Z',
    expiresAt: '2024-06-10T11:45:00Z',
  },
];
